module.exports = __webpack_public_path__ + "img/secretary.f9d2057d.png";